let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4JohX")).then(() => parcelRequire('4nPln'));